import React, { useState, useEffect } from 'react';

import OnDemandModalNotLogged from '../OnDemandModals/OnDemandModalNotLogged';
import ProOnDemandModalIsLogged from './ProOnDemandModalIsLogged';
import LoadIcon from '../../LoadIcon';

const ProOnDemandModalScreen = ({ isFullyRegistered,
  userName, userRoles, userEmail, token, loadTokenForLS, isUserVerified, language, translations, image, closeModal, postVideoUrl, otherOptionsButtonUrl, userTrialWasUsed, userPostalCode, userCountry, userSubscriptionDetails, history, postVideoRole, sourceWeb,
}) => {
  const [screenStatus, setScreenStatus] = useState('loading');

  useEffect(() => {
    if (!userEmail || !isFullyRegistered) setScreenStatus('socialLogin');
    else setScreenStatus('logged');
  }, [isFullyRegistered, userEmail]);

  const handleOnDemandScreenStatus = (screenStatusFromFn) => {
    setScreenStatus(screenStatusFromFn);
  };

  const renderLogic = () => {
    switch (screenStatus) {
      case 'loading':
        return (
          <div className="bg-gray200 p-8 sm:p-2 w-full">
            <LoadIcon color="black" type="ThreeDots" />
          </div>
        );
      case 'socialLogin':
        return (
          <>
            <OnDemandModalNotLogged isFromPro language={language} loadTokenForLS={loadTokenForLS} handleOnDemandScreenStatus={handleOnDemandScreenStatus} translations={translations} sourceWeb={sourceWeb} />
          </>
        );
      case 'logged':
        return (
          <ProOnDemandModalIsLogged userEmail={userEmail} language={language} loadTokenForLS={loadTokenForLS} handleOnDemandScreenStatus={handleOnDemandScreenStatus} translations={translations} image={image} closeModal={closeModal} postVideoUrl={postVideoUrl} postVideoRole={postVideoRole} userRoles={userRoles} />
        );
      default:
        return (
          <div
            className="bg-gray200 p-8 sm:p-2 w-full"
          >
            <div>please review...</div>
          </div>
        );
    }
  };

  return (
    <div className="bg-white-dark">
      {renderLogic()}
    </div>
  );
};

export default ProOnDemandModalScreen;
